import { render, staticRenderFns } from "./TransactionCategories.vue?vue&type=template&id=520c0bc3&"
import script from "./TransactionCategories.vue?vue&type=script&lang=js&"
export * from "./TransactionCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports